import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import { HttpStatusCode } from "axios";

export namespace ApiResponseErrorUtils {
  export function handleStatusCode(apiResponse: ApiResponseV2<unknown>, customConsoleLog?: string) {
    switch (apiResponse.getHttpStatusCode()) {
      case HttpStatusCode.Unauthorized: {
        NotificationService.warn("Access denied");
        break;
      }
      default: {
        NotificationService.error("There was an error processing the action");
        break;
      }
    }
    const errorString = (customConsoleLog || "") + " Error message: " + apiResponse.getMessage();
    console.log(errorString);
  }
}
